import * as React from "react";

import { Warning } from "./Icons";

export const WarningBlock: React.FC<{
  left?: boolean;
  hidden?: boolean;
  classNames?: string;
}> = ({ children, left, hidden, classNames }) => (
  <div
    className={`bg-grey-light max-w-md ${
      !left ? "mx-auto" : ""
    } ${classNames} ${
      hidden ? "hidden" : "flex"
    } text-left py-4 px-5 mb-8 items-center`}
  >
    <div className="mr-4">
      <Warning />
    </div>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/WarningBlock.tsx